import parse, { domToReact, Element } from 'html-react-parser';
import { InboxMessage } from 'modules/types/Inbox';
import {
  StyledDateTimeContainer,
  StyledInboxMessageCardContainer,
  StyledInboxMessageCardHeader,
  StyledInboxMessageCardPreview,
  StyledInboxMessageCardTitle,
  StyledMessageCardLabel,
} from './styled';

export interface InboxMessageCardProps {
  message: InboxMessage;
  active?: boolean;
  onClick?: () => void;
}

export const InboxMessageCard: React.FC<InboxMessageCardProps> = ({
  message,
  active,
  onClick,
}) => (
  <StyledInboxMessageCardContainer onClick={onClick} active={active}>
    <StyledInboxMessageCardHeader>
      <StyledMessageCardLabel>{message.sender}</StyledMessageCardLabel>
      <StyledDateTimeContainer>
        <StyledMessageCardLabel>{message.time}</StyledMessageCardLabel>
        <StyledMessageCardLabel>{message.date}</StyledMessageCardLabel>
      </StyledDateTimeContainer>
    </StyledInboxMessageCardHeader>
    <StyledInboxMessageCardTitle read={message.read}>
      {message.title}
    </StyledInboxMessageCardTitle>
    <StyledInboxMessageCardPreview read={message.read}>
      {parse(message.content, {
        replace: (domNode) => {
          if (domNode instanceof Element && domNode.children) {
            /* Preview needs to be just one line of text. In message preview,
             * all HTML tags are replaced with react fragments. That way,
             * all newlines and other formatting caused by HTML tags is removed,
             * and message is formatted as one long line needed for preview. */
            return <>{domToReact(domNode.children)}</>;
          }
          return domNode;
        },
      })}
    </StyledInboxMessageCardPreview>
  </StyledInboxMessageCardContainer>
);
